/** Debounce window for coalescing cart line quantity sync requests. */
export const CHECKOUT_LINES_SYNC_DEBOUNCE_MS = 400;

/** Debounce window for coalescing payment gateway initialize requests. */
export const PAYMENT_GATEWAY_FETCH_DEBOUNCE_MS = 400;
